<template>
  <form name="modal" :scrollable="true" width="300px" height="auto">
    <b-loading v-model="isLoading"></b-loading>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">ゴールド購入</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>

      <section class="modal-card-body">
        <p class="modal-card-body-message">合計 {{ doronAmount }} ゴールドを購入します。</p>
        <p class="modal-card-body-message"><span class="thin">ご請求金額 {{ price }} 円</span></p>
        <p class="modal-card-body-message"><span class="thin"><a href="https://www.elkatsu.com/mypage/payment">クレジットカード未登録の方はコチラ</a></span></p>
        <b-select
          class="select-box"
          expanded
          v-model="paymentMethod"
          :placeholder="paymentMethods ? 'カードを選択してください' : 'クレジットカードが登録されていません'"
        >
          <option
            v-for="(paymentMethod, index) in paymentMethods"
            :key="index"
            :value="paymentMethod"
          >
            下4桁  {{ paymentMethod.last4 }}
          </option>
        </b-select>
        <router-link
          v-if="needToRegistPaymentMethod"
          to="/payment"
          @click.native="$emit('close')"
          >支払い方法の登録</router-link
        >
      </section>

      <footer class="modal-card-foot">
        <div class="button close" @click="$emit('close')">キャンセル</div>
        <div class="button submit" @click="onClickSubmit">購入</div>
      </footer>
    </div>
  </form>
</template>

<script>
import { analyticsLog } from '@/utils/analytics';

export default {
  name: 'DoronPurchaseFormModal',
  props: {
    doronAmount: Number,
    freeDoronAmount: Number,
    doronToYenRate: Number
  },
  computed: {
    price() {
      return (this.doronAmount * this.doronToYenRate).toFixed();
    }
  },
  async created() {
    await this.$store.dispatch('payment/loadCustomer', {
      userId: this.$store.state.auth.uid,
      email: this.$store.state.auth.email
    });
    this.paymentMethods = this.$store.getters['payment/paymentMethods'];
    let usualId = this.$store.getters['payment/defaultCardID'];
    for (let item of this.paymentMethods) {
      if (item.id == usualId) {
        this.paymentMethod = item;
        break;
      }
    }
    this.isLoading = false;
  },
  data() {
    return {
      paymentMethod: null,
      paymentMethods: [],
      isLoading: true,
      needToRegistPaymentMethod: false
    };
  },
  methods: {
    async onClickSubmit() {
      if (this.paymentMethods.length == 0) {
        this.$buefy.toast.open({
          duration: 3000,
          message: '支払い方法の登録をお願いします',
          type: 'is-danger'
        });
        this.needToRegistPaymentMethod = true;

        return;
      }

      if (!this.paymentMethod) {
        this.$buefy.toast.open({
          duration: 3000,
          message: '支払い方法の選択をお願いします',
          type: 'is-danger'
        });

        return;
      }

      this.isLoading = true;
      let result = await this.$store.dispatch('doron/purchaseDoron', {
        userId: this.$store.state.auth.uid,
        cardId: this.paymentMethod.id,
        amount: this.doronAmount,
        freeAmount: this.freeDoronAmount,
        price: this.price
      });

      this.isLoading = false;

      if (result) {
        analyticsLog('ゴールド購入完了【動作完了】', {'課金額': this.price});
        this.$emit('success');
      } else {
        this.$emit('failure');
      }

      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/modal.scss';
.select-box {
  margin-top: 20px;
}
.modal-card-body-message + .modal-card-body-message {
  margin-top: 10px;
}
</style>
